import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'recommend-option-toggle',
    templateUrl: './recommend-option-toggle.component.html',
    styleUrls: ['./recommend-option-toggle.component.scss'],
    standalone: false
})
export class RecommendOptionToggleComponent implements OnInit, OnChanges {
    @Input() value: boolean;
    @Input() isShort: boolean = false;

    @Output() change = new EventEmitter<MatSlideToggleChange>();

    isRecommended: boolean;

    constructor() { }

    ngOnInit() {
      this.isRecommended = this.value;
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes.value && changes.value.previousValue !== changes.value.currentValue) {
        this.isRecommended = changes.value.currentValue;
      }
    }

    onToggle(event: MatSlideToggleChange) {
      this.isRecommended = event.checked;
      this.change.emit(event);
    }
}
